import { RouteInfo } from "./sidebar.metadata";
import { ModuleName } from "src/app/core/models/permission";

export const ROUTES: RouteInfo[] = [
  // {
  //   path: "",
  //   title: "MENUITEMS.MAIN.TEXT",
  //   moduleName: "",
  //   iconType: "",
  //   icon: "",
  //   class: "",
  //   groupTitle: true,
  //   badge: "",
  //   badgeClass: "",
  //   submenu: [],
  // },

  // ==================== BANK OFFICER DASHBOARDS ====================
  {
    path: "/bank-officer/bank-dashboard",
    title: "Dashboard",
    moduleName: "bank-officer",
    iconType: "feather",
    icon: "monitor",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    modules: [ModuleName.OVERALL_DASHBOARD],
    submenu: [],
  },
  // {
  //   path: "/bank-officer/bank-branch-dashboard",
  //   title: "Bank Branch Officer",
  //   moduleName: "bank-officer",
  //   iconType: "feather",
  //   icon: "monitor",
  //   class: "",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   modules: [ModuleName.BRANCH_DASHBOARD, ModuleName.CHURCH],
  //   submenu: [],
  // },
  {
    path: "/bank-officer/rm-dashboard",
    title: "Relationship Officer",
    moduleName: "bank-officer",
    iconType: "feather",
    icon: "monitor",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    modules: [ModuleName.BRANCH_DASHBOARD],
    submenu: [],
  },

    // ==================== CHURCH ADMIN DASHBOARD ====================
  {
    path: "/admin/dashboard",
    title: "Dashboard",
    moduleName: "dashboard",
    iconType: "feather",
    icon: "monitor",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    modules: [ModuleName.CHURCH_DASHBOARD],
    submenu: [],
  },

  // ==================== STAFF MANAGEMENT ====================
  {
    path: "",
    title: "Staff Management",
    moduleName: "staff-management",
    iconType: "feather",
    icon: "user",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    modules: [ModuleName.USER_MANAGEMENT, ModuleName.ROLE_MANAGEMENT, ModuleName.BRANCH],
    submenu: [
      {
        path: "/staff-management/roles",
        title: "Role Management",
        moduleName: "staff-management",
        iconType: "feather",
        icon: "monitor",
        class: "",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        modules: [ModuleName.ROLE_MANAGEMENT],
        submenu: [],
      },
      {
        path: "/staff-management/users",
        title: "User Management",
        moduleName: "staff-management",
        iconType: "feather",
        icon: "monitor",
        class: "",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        modules: [ModuleName.USER_MANAGEMENT],
        submenu: [],
      },
      {
        path: "/staff-management/bank-branches",
        title: "Bank Branches",
        moduleName: "staff-management",
        iconType: "feather",
        icon: "monitor",
        class: "",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        modules: [ModuleName.BRANCH],
        submenu: [],
      },
    ],
  },

  // ==================== CHURCH CONFIGURATION ====================
  {
    path: "",
    title: "Church Configuration",
    moduleName: "church-configuration",
    iconType: "feather",
    icon: "shield",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    modules: [ModuleName.CHURCH, 'GOVERNANCE', ModuleName.MEMBER_TRANSFER, ModuleName.POLL],
    permissions: [
      { module: ModuleName.CHURCH, action: 'ACCESS_ALL_UNITS' },
      { module: ModuleName.CHURCH, action: 'ACCESS_BRANCH_UNITS' },
      { module: ModuleName.CHURCH, action: 'ACCESS_OWN_UNITS' },
      { module: 'GOVERNANCE', action: 'VIEW' },
      { module: 'GOVERNANCE', action: 'PROPOSE' },
      { module: 'GOVERNANCE', action: 'CHECK' },
      { module: 'GOVERNANCE', action: 'DELEGATE_CHECKER' },
      { module: ModuleName.MEMBER_TRANSFER, action: 'VIEW' },
      { module: ModuleName.MEMBER_TRANSFER, action: 'INITIATE' },
      { module: ModuleName.MEMBER_TRANSFER, action: 'DECIDE' },
      { module: ModuleName.POLL, action: 'VIEW' },
      { module: ModuleName.POLL, action: 'MANAGE' },
      { module: ModuleName.POLL, action: 'VIEW_RESULTS' },
    ],
    submenu: [
      {
        path: "/church-configuration/rm-church-units",
        title: "Church Units",
        moduleName: "church-units",
        iconType: "feather",
        icon: "home",
        class: "",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        modules: [ModuleName.CHURCH],
        permissions: [
          { module: ModuleName.CHURCH, action: 'ACCESS_ALL_UNITS' },
          { module: ModuleName.CHURCH, action: 'ACCESS_BRANCH_UNITS' },
          { module: ModuleName.CHURCH, action: 'ACCESS_OWN_UNITS' },
        ],
        submenu: [],
      },
      {
        path: "/church-configuration/leadership-governance",
        title: "Leadership & Approvals",
        moduleName: "church-governance",
        iconType: "feather",
        icon: "users",
        class: "",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        modules: ['GOVERNANCE'],
        permissions: [
          { module: 'GOVERNANCE', action: 'VIEW' },
          { module: 'GOVERNANCE', action: 'PROPOSE' },
          { module: 'GOVERNANCE', action: 'CHECK' },
          { module: 'GOVERNANCE', action: 'DELEGATE_CHECKER' },
        ],
        submenu: [],
      },
      {
        path: "/church-configuration/member-transfers",
        title: "Member Transfers",
        moduleName: "member-transfer",
        iconType: "feather",
        icon: "repeat",
        class: "",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        modules: [ModuleName.MEMBER_TRANSFER],
        permissions: [
          { module: ModuleName.MEMBER_TRANSFER, action: 'VIEW' },
          { module: ModuleName.MEMBER_TRANSFER, action: 'INITIATE' },
          { module: ModuleName.MEMBER_TRANSFER, action: 'DECIDE' },
        ],
        submenu: [],
      },
      {
        path: "/church-configuration/polls",
        title: "Polls",
        moduleName: "polls",
        iconType: "feather",
        icon: "bar-chart-2",
        class: "",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        modules: [ModuleName.POLL],
        permissions: [
          { module: ModuleName.POLL, action: 'VIEW' },
          { module: ModuleName.POLL, action: 'MANAGE' },
          { module: ModuleName.POLL, action: 'VIEW_RESULTS' },
        ],
        submenu: [],
      },
    //   {
    //     path: "/church-configuration/profile-setup",
    //     title: "Profile Set-Up",
    //     moduleName: "church-configuration",
    //     iconType: "feather",
    //     icon: "award",
    //     class: "",
    //     groupTitle: false,
    //     badge: "",
    //     badgeClass: "",
    //     modules: [ModuleName.CHURCH_PROFILE],
    //     submenu: [],
    //   },
    ],
  },

  {
    path: "/finance-configuration/manage-finance",
    title: "Caritas Accounts",
    moduleName: "finance-configuration",
    iconType: "feather",
    icon: "credit-card",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    modules: [ModuleName.CARITAS, ModuleName.ACCOUNT_GOVERNANCE],
    permissions: [
      { module: 'ACCOUNT_GOVERNANCE', action: 'VIEW' },
      { module: 'ACCOUNT_GOVERNANCE', action: 'PROPOSE' },
      { module: 'CARITAS', action: 'VIEW_ALL_CONFIGS' },
    ],
    submenu: [],
  },
  {
    path: "/finance-configuration/cash-governance",
    title: "Cash Governance",
    moduleName: "finance-configuration",
    iconType: "feather",
    icon: "check-square",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    modules: [ModuleName.CASH_GOVERNANCE],
    permissions: [
      { module: 'CASH_GOVERNANCE', action: 'VIEW' },
      { module: 'CASH_GOVERNANCE', action: 'PROPOSE' }
    ],
    submenu: [],
  },



  // ==================== MEMBERS ====================
  {
    path: "",
    title: "Members",
    moduleName: "user",
    iconType: "feather",
    icon: "user",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    modules: [ModuleName.CHURCH_MEMBERS],
    submenu: [
      {
        path: "/admin/user-accounts/active-accounts",
        title: "Registered Members",
        moduleName: "active-accounts",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        modules: [ModuleName.CHURCH_MEMBERS],
        submenu: [],
      },
      {
        path: "/admin/outstation/outstation-details",
        title: "Member per Branch",
        moduleName: "members",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        modules: [ModuleName.CHURCH_MEMBERS],
        submenu: [],
      },
      {
        path: "/admin/community/communitydetails",
        title: "Member per Sub-Branch",
        moduleName: "membersCommunity",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        modules: [ModuleName.CHURCH_MEMBERS],
        submenu: [],
      },
      {
        path: "/admin/groups/groups-details",
        title: "Members per Group",
        moduleName: "membersGroups",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        modules: [ModuleName.CHURCH_MEMBERS],
        submenu: [],
      },
      {
        path: "/admin/family/family-details",
        title: "Members per family",
        moduleName: "MembersFamily",
        iconType: "feather",
        icon: "users",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        modules: [ModuleName.CHURCH_MEMBERS],
        submenu: [],
      },
      {
        path: "/admin/user-accounts/add-account",
        title: "Register New Member",
        moduleName: "add-account",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        modules: [ModuleName.CHURCH_MEMBERS],
        submenu: [],
      },
      {
        path: "/admin/user-accounts/system-users",
        title: "System Users",
        moduleName: "system-users",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        modules: [ModuleName.CHURCH_MEMBERS],
        submenu: [],
      },
    ],
  },

  // ==================== CHURCH SETUP ====================
  {
    path: "",
    title: "Church Set-Up",
    moduleName: "admin",
    iconType: "feather",
    icon: "home",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    modules: [ModuleName.CHURCH_SETUP],
    submenu: [
      {
        path: "/admin/outstation",
        title: "Out Stations",
        moduleName: "outstation",
        iconType: "feather",
        icon: "edit",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        modules: [ModuleName.CHURCH_SETUP],
        submenu: [],
      },
      {
        path: "/admin/community",
        title: "Small Christian Communities",
        moduleName: "community",
        iconType: "feather",
        icon: "edit",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        modules: [ModuleName.CHURCH_SETUP],
        submenu: [],
      },
      {
        path: "/admin/groups",
        title: "Groups",
        moduleName: "groups",
        iconType: "feather",
        icon: "edit",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        modules: [ModuleName.CHURCH_SETUP],
        submenu: [],
      },
    ],
  },

  // ==================== FAMILIES ====================
  {
    path: "",
    title: "Families",
    moduleName: "/admin/family",
    iconType: "feather",
    icon: "users",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    modules: [ModuleName.CHURCH_MEMBERS],
    submenu: [
      {
        path: "/admin/family",
        title: "All Families",
        moduleName: "family",
        iconType: "feather",
        icon: "edit",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        modules: [ModuleName.CHURCH_MEMBERS],
        submenu: [],
      },
    ],
  },

  // ==================== MEMBERSHIP JOURNEY ====================
  {
    path: "",
    title: "Membership Journey",
    moduleName: "stages",
    iconType: "feather",
    icon: "award",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    modules: [ModuleName.CHURCH_MEMBERSHIP_JOURNEY],
    submenu: [
      {
        path: "/admin/stages",
        title: "All Stages",
        moduleName: "allstages",
        iconType: "feather",
        icon: "edit",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        modules: [ModuleName.CHURCH_MEMBERSHIP_JOURNEY],
        submenu: [],
      },
      {
        path: "/admin/enrollments",
        title: "Enrollments",
        moduleName: "enrollments",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        modules: [ModuleName.CHURCH_MEMBERSHIP_JOURNEY],
        submenu: [],
      },
    ],
  },

  // ==================== OFFERINGS ====================
  {
    path: "/admin/giving/view-offerings",
    title: "Offerings",
    moduleName: "giving",
    iconType: "feather",
    icon: "heart",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    modules: [ModuleName.CHURCH_OFFERINGS],
    submenu: [],
  },

  // ==================== RESOURCES ====================
  {
    path: "/admin/resources/view-resource",
    title: "Resources",
    moduleName: "resources",
    iconType: "feather",
    icon: "book-open",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    modules: [ModuleName.CHURCH_RESOURCES],
    submenu: [
      {
        path: "/admin/resources/church-history",
        title: "Church History",
        moduleName: "resource",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        modules: [ModuleName.CHURCH_RESOURCES],
        submenu: [],
      },
      {
        path: "/admin/resources/bible-readings",
        title: "Bible Readings",
        moduleName: "bible",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        modules: [ModuleName.CHURCH_RESOURCES],
        submenu: [],
      },
      {
        path: "/admin/resources/social-media",
        title: "Social Media Accounts",
        moduleName: "socials",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        modules: [ModuleName.CHURCH_RESOURCES],
        submenu: [],
      },
      {
        path: "/admin/resources/prayers",
        title: "Prayers",
        moduleName: "prayers",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        modules: [ModuleName.CHURCH_RESOURCES],
        submenu: [],
      },
      {
        path: "/admin/resources/songs",
        title: "Songs",
        moduleName: "songs",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        modules: [ModuleName.CHURCH_RESOURCES],
        submenu: [],
      },
    ],
  },

  // ==================== SERVICE ====================
  {
    path: "mass",
    title: "Service",
    moduleName: "mass",
    iconType: "feather",
    icon: "user",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    modules: [ModuleName.CHURCH_SERVICE, ModuleName.CHURCH_CLERGY, ModuleName.CHURCH_MESSAGES, ModuleName.CLERGY_CATEGORY],
    submenu: [
        {
        path: "mass/clergy",
        title: "Manage Clergy",
        moduleName: "manage-mass",
        iconType: "feather",
        icon: "edit",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        modules: [ModuleName.CHURCH_CLERGY],
        submenu: [],
      },
      {
        path: "mass/clergy-identity",
        title: "Clergy Identity",
        moduleName: "clergy-identity",
        iconType: "feather",
        icon: "user-check",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        // This is the church-side identity workflow. A bank emergency
        // approval grant alone must not expose the parish menu.
        modules: [ModuleName.CHURCH_CLERGY],
        submenu: [],
      },
      {
        path: "mass/clergy-categories",
        title: "Clergy Categories",
        moduleName: "clergy-categories",
        iconType: "feather",
        icon: "list",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        modules: [ModuleName.CLERGY_CATEGORY],
        permissions: [{ module: ModuleName.CLERGY_CATEGORY, action: 'MANAGE' }],
        submenu: [],
      },
      {
        path: "mass/mass-service",
        title: "Manage Services",
        moduleName: "mass-service",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        modules: [ModuleName.CHURCH_SERVICE],
        submenu: [],
      },
      {
        path: "mass/regular-services",
        title: "Regular Services",
        moduleName: "regular-services",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        modules: [ModuleName.CHURCH_SERVICE],
        submenu: [],
      },
      {
        path: "mass/message",
        title: "Post Message",
        moduleName: "post-message",
        iconType: "feather",
        icon: "edit",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        modules: [ModuleName.CHURCH_MESSAGES],
        submenu: [],
      },
    ],
  },

  // ==================== PROJECTS ====================
  {
    path: "projects",
    title: "Projects",
    moduleName: "projects",
    iconType: "feather",
    icon: "folder",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    modules: [ModuleName.CHURCH_PROJECTS],
    submenu: [
      {
        path: "projects/parish-events",
        title: "Active Projects",
        moduleName: "parish-events",
        iconType: "feather",
        icon: "edit",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        modules: [ModuleName.CHURCH_PROJECTS],
        submenu: [],
      },
    ],
  },

  // ==================== OTHER CHURCH PROJECTS ====================
  {
    path: "diocese-projects",
    title: "Other Church Projects",
    moduleName: "diocese-projects",
    iconType: "feather",
    icon: "calendar",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    modules: [ModuleName.CHURCH_OTHER_PROJECTS],
    submenu: [
      {
        path: "diocese-projects/active-project",
        title: "Active Projects",
        moduleName: "active-project",
        iconType: "feather",
        icon: "edit",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        modules: [ModuleName.CHURCH_OTHER_PROJECTS],
        submenu: [],
      },
    ],
  },

  // ==================== DONATIONS ====================
  {
    path: "donations",
    title: "Donations",
    moduleName: "donations",
    iconType: "feather",
    icon: "folder",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    modules: [ModuleName.CHURCH_DONATIONS],
    submenu: [
      {
        path: "/admin/giving/view-donations",
        title: "Donations",
        moduleName: "giving",
        iconType: "feather",
        icon: "edit",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        modules: [ModuleName.CHURCH_DONATIONS],
        submenu: [],
      },
    ],
  },

  // ==================== ENQUIRIES ====================
  {
    path: "admin/enquiries",
    title: "Enquiries",
    moduleName: "enquiries",
    iconType: "feather",
    icon: "user",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    modules: [ModuleName.CHURCH_ENQUIRIES, ModuleName.CHURCH_PRAYER_REQUESTS],
    submenu: [
      {
        path: "admin/enquiries/general-enquiries",
        title: "General Enquiries",
        moduleName: "general-enquiries",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        modules: [ModuleName.CHURCH_ENQUIRIES],
        submenu: [],
      },
      {
        path: "admin/enquiries/prayer-requests",
        title: "Prayer Requests",
        moduleName: "enquiries",
        iconType: "feather",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        modules: [ModuleName.CHURCH_PRAYER_REQUESTS],
        submenu: [],
      },
    ],
  },

  // ==================== CHURCH ACTIVITIES ====================
  {
    path: "",
    title: "Church Activities",
    moduleName: "church-activities",
    iconType: "feather",
    icon: "activity",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    modules: [ModuleName.CHURCH_ANNOUNCEMENTS, ModuleName.CHURCH_EVENTS],
    submenu: [
      {
        path: "church-activities/announce/pending",
        title: "Announcements",
        moduleName: "church-activities",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        modules: [ModuleName.CHURCH_ANNOUNCEMENTS],
        submenu: [],
      },
      {
        path: "/admin/church-activities/view-church-activities",
        title: "Activities",
        moduleName: "activity-management",
        iconType: "feather",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        modules: [ModuleName.CHURCH_EVENTS],
        submenu: [],
      },
    ],
  },

  // ==================== SYSTEM SETTINGS ====================
  {
    path: "/admin/settings",
    title: "System Settings",
    moduleName: "system",
    iconType: "feather",
    icon: "settings",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    modules: [ModuleName.CHURCH_SETTINGS],
    submenu: [],
  },
];
